<template>
    <Login v-if="$route.path === '/login'" />
    <Error v-else-if="$route.path === '/error'" />
    <Access v-else-if="$route.path === '/access'" />
    <NotFound v-else-if="$route.path === '/notfound'" />
    <App v-else :menuTheme="menuTheme" />
</template>

<script>
import App from './App.vue'
import Error from './pages/Error'
import Access from './pages/Access'
import Login from './pages/Login'
import NotFound from './pages/NotFound'

export default {
    data() {
        return {
            // tema fixo: o painel de configuração do template foi removido junto com a topbar
            menuTheme: "dark",
        }
    },
    components: {
        "App": App,
        "Error": Error,
        "Access": Access,
        "Login": Login,
        "NotFound": NotFound
    }
}
</script>

<style scoped></style>
